<template>
  <div
    ref="emailVerificationModal" class="modal modal-v modal-v--normal fade" id="emailVerificationModal"
    tabindex="-1" role="dialog" aria-labelledby="emailVerificationModalLabel" aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <i class="demo-icon icon-close"></i>
        </button>
        <div class="modal-body">
          <img src="../../../images/modals/notifications-modal.png" alt="">
          <h2 class="title">
            {{ trans.get('profile:edit.email_verification_modal.header') }}<span>.</span>
          </h2>
          <p class="desc">
            {{ trans.get('profile:edit.email_verification_modal.description') }}
          </p>

          <ResponseComponent :response="response" class="text-center desc desc--color-secondary">
          </ResponseComponent>

          <form id="emailVerificationForm" @submit.prevent="sendForm">
            <div class="desc">
              <label for="email">
                {{ trans.get('profile:edit.email_verification_modal.enter_email_label') }}:
              </label>
            </div>
            <div class="form-row">
              <div class="col">

                <input
                  v-model="modalEmail" id="email" type="email" class="input--primary"
                  :placeholder="trans.get('profile:edit.email_verification_modal.enter_email_label')"
                  name="email" required
                >
              </div>
            </div>
          </form>

          <div class="buttons-container">
            <button form="emailVerificationForm" type="submit" class="button button--primary">
              {{ trans.get('profile:edit.email_verification_modal.send_verivication_message_button') }}
            </button>

            <button
              type="button" class="button button__text-icon button__text-icon--modal"
              data-dismiss="modal"
            >
              <i class="demo-icon icon-close"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HandleResponse from '../../../../js/front/scripts/vueHandleResponseErrors';
import ResponseComponent from '../../../../js/front/components/ResponseComponent';

export default {
  name: 'EmailVerificationModal',
  components: { ResponseComponent },
  mixins: [HandleResponse],
  props: { email: String },
  data() {
    return {
      open: false,
      modalEmail: null,
      messages: null,
    };
  },
  computed: {},
  watch: {
    open(val) {
      if (val) {
        $(this.$refs.emailVerificationModal).modal('show');
      } else {
        $(this.$refs.emailVerificationModal).modal('hide');
      }
    },
  },
  methods: {
    sendForm: function () {
      this.messages = null;
      axios.post(zRoute('ajax.verification.email.send'), {
        email: this.modalEmail,
      }).then((response) => {
        this.handleResponseMessage(response.data);

        setTimeout(() => {
          this.open = false;
        }, 1000);
      }).catch((error) => {
        this.handleResponseErrors(error.response.data);
      });
    }
  },
  mounted() {
    this.modalEmail = this.email;

    this.$eventHub.$on('EmailVerificationModalOpen', () => {
      this.open = true;
    });

    $(this.$refs.emailVerificationModal).on('hidden.bs.modal', () => {
      this.open = false;
    });
  }
};
</script>

<style scoped>

</style>
